module.exports = __webpack_public_path__ + "img/painPerceptionScale_4.71cb3681.png";